import { memo } from "react";
import { NotificationBadge } from "@/shared/components/NotificationBadge";
import { useChatUnreadCount } from "../hooks/useChatUnreadCount";

/**
 * Sub-item badge under "Communication" in the sidebar. Always calls the
 * unread hook with `enabled: true` — safe because Navigation only renders
 * this component when the Chat sub-item is part of the user's nav tree
 * (i.e. `service_chat` is on). The query key is shared with `Navigation`'s
 * own call, so React Query dedups the fetch.
 */
export const ChatCounter = memo(() => {
  const count = useChatUnreadCount();
  return <NotificationBadge count={count} />;
});

ChatCounter.displayName = "ChatCounter";
